import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch } from "../reducers";

export type StatusMessagesSlice = {
  showSuccessMessage: boolean;
  submitSucceededMessageHeader: string;
  submitSucceededMessageContent: string;
  showFailureMessage: boolean;
  submitFailedMessageHeader: string;
  submitFailedMessageContent: string;
  isLoading: boolean;
};

const initialState: StatusMessagesSlice = {
  showSuccessMessage: false,
  submitSucceededMessageHeader: "",
  submitSucceededMessageContent: "",
  showFailureMessage: false,
  submitFailedMessageHeader: "",
  submitFailedMessageContent: "",
  isLoading: false
};

const statusMessagesSlice = createSlice({
  name: "statusMessages",
  initialState,
  reducers: {
    showSuccessMessage(state, action: PayloadAction<{ header: string; message: string }>) {
      const { header, message } = action.payload;
      state.isLoading = false;
      state.showSuccessMessage = true;
      state.submitSucceededMessageHeader = header;
      state.submitSucceededMessageContent = message;
    },
    hideSuccessMessage(state) {
      state.showSuccessMessage = false;
      state.submitSucceededMessageHeader = "";
      state.submitSucceededMessageContent = "";
    },
    showFailureMessage(state, action: PayloadAction<{ header: string; message: string }>) {
      const { header, message } = action.payload;
      state.isLoading = false;
      state.showFailureMessage = true;
      state.submitFailedMessageHeader = header;
      state.submitFailedMessageContent = message;
    },
    hideFailureMessage(state) {
      state.showFailureMessage = false;
      state.submitFailedMessageHeader = "";
      state.submitFailedMessageContent = "";
    },
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    }
  }
});

export const showSuccessMessage = (header: string, message = "") => (dispatch: AppDispatch) =>
  dispatch(statusMessagesSlice.actions.showSuccessMessage({ header, message }));

export const showFailureMessage = (header: string, message: string) => (dispatch: AppDispatch) =>
  dispatch(statusMessagesSlice.actions.showFailureMessage({ header, message }));

export const { hideSuccessMessage, hideFailureMessage, setIsLoading } = statusMessagesSlice.actions;

export default statusMessagesSlice.reducer;
